import GMaps from '../vendor/gmaps';
import GoogleMapsCustomOverlay from '../vendor/google-maps-custom-overlay'
import _ from 'underscore'

function MapsCommon(form, listContainer, paramsKey, selectCallback) {
  this.$form = form;
  this.$listContainer = listContainer;
  this.paramsKey = paramsKey;
  this.selectCallback = selectCallback;
  this.$userGeolocationLink = this.$form.find('#user-geolocation');
  this.$geolocationErrorWrapper = this.$form.find('#geolocation-error');
}

const fn = MapsCommon.prototype;

const USA_CENTER_LAT = 39.828175;
const USA_CENTER_LNG = -98.579500;
const INITIAL_ZOOM = 4;
const RESULTS_ZOOM = 11;
const SELECTED_ZOOM = 15;
const ENABLE_HIGH_ACCURACY = true;
const MAXIMUM_AGE = 60000;

fn._init = function() {
  this.$form.on('ajax:before', _.bind(this._showLoading, this));
  this.$form.on('ajax:complete', _.bind(this._handleResponse, this));
  this.$userGeolocationLink.on('click', _.bind(this._askUserGeolocation, this));
};

fn._showLoading = function() {
  const $paragraph = $('<p>').addClass('text-center').text(window.locationTranslations.loadingResults);
  this.$listContainer.empty().append($paragraph);
};

fn.createMap = function() {

  if (this.locationsMap) {
    return;
  }

  this.locationsMap = new GMaps({
    div: '#map',
    scrollwheel: true,
    mapTypeControl: false,
    streetViewControl: false,
    lat: USA_CENTER_LAT,
    lng: USA_CENTER_LNG,
    zoom: INITIAL_ZOOM
  })
};

fn._handleResponse = function(event) {
  const xhr = event.detail[0]
  this._removeOverlays();
  this._placeOverlays(xhr.responseText);
};

fn._placeOverlays = function(results) {
  this.$listContainer.html(results);

  const locations = this.$listContainer.find('li');

  locations.on('click', _.bind(function(event) {
    const clickedLocation = $(event.currentTarget);
    if (clickedLocation.hasClass('selected')) {
      this._unselectLocation(clickedLocation, this.$listContainer);
    } else {
      this._selectLocation(clickedLocation);
    }
  }, this)).on('keypress', _.bind(function(event) {
    if (event.keyCode === 13 || event.keyCode === 32) { // enter or spacebar
      this._selectLocation($(event.currentTarget));
    }
  }, this));

  locations.each(_.bind(this._placeOverlay, this));

  if (locations.length > 0) {
    this.locationsMap.setZoom(RESULTS_ZOOM);
  }
};

fn._placeOverlay = function(index, location) {
  const $location = $(location);
  new GoogleMapsCustomOverlay(
    parseFloat($location.data('lat')),
    parseFloat($location.data('lng')),
    this.locationsMap.map,
    this._overlayClicked.bind(this),
    {
      overlayIndex: index + 1,
      className: 'map-marker'
    }
  )
  if (index === 0) {
    this._centerOn($location);
  }
};

fn._centerOn = function(location) {
  const center = new google.maps.LatLng(
    parseFloat(location.data('lat')),
    parseFloat(location.data('lng'))
  );
  this.locationsMap.map.panTo(center);
  this.locationsMap.map.setZoom(SELECTED_ZOOM);
};

fn._overlayClicked = function(overlay) {
  const index = overlay.dataset['overlay_index'];
  const $li = this.$listContainer.find('li[data-marker-index="' + index + '"]');
  this._selectLocation($li);
};

fn._removeOverlays = function() {
  $('.map-marker[data-overlay_index]').remove();
};

fn._selectLocation = function(li) {
  $('.map-marker[data-overlay_index]').removeClass('selected');
  $('.map-marker[data-overlay_index="' + li.data('marker-index') + '"]').addClass('selected');
  this.$listContainer.find('li').removeClass('selected');
  li.addClass('selected');
  this._centerOn(li);
  const ul = li.parent();
  const listPadding = ul.innerWidth() - ul.width();
  ul.animate({
    scrollTop: li.parent().scrollTop() + li.position().top - (listPadding / 2)
  }, 300);

  if (this.selectCallback) {
    this.selectCallback(li);
  }
};

fn._unselectLocation = function (li, listContainer) {
  $('.map-marker[data-overlay_index]').removeClass('selected');
  listContainer.find('li').removeClass('selected');
  li.removeClass('selected');
  this.locationsMap.setZoom(RESULTS_ZOOM);
};

fn._askUserGeolocation = function(event) {
  event.preventDefault();
  const geolocationOptions = {
    enableHighAccuracy: ENABLE_HIGH_ACCURACY,
    maximumAge: MAXIMUM_AGE
  };

  navigator.geolocation.getCurrentPosition(
    _.bind(this._onGeolocationSuccess, this),
    _.bind(this._onGeolocationError, this), this,
    geolocationOptions
  );
};

fn._onGeolocationSuccess = function(position) {
  this._showLoading();
  this.$geolocationErrorWrapper.hide();

  const latitude = position.coords.latitude;
  const longitude = position.coords.longitude;
  const latLng = new google.maps.LatLng(latitude, longitude);

  this.locationsMap.panTo(latLng);
  this._setMapZoom(RESULTS_ZOOM);
  this._fetchFromMap();
};

fn._onGeolocationError = function() {
  this.$geolocationErrorWrapper.show();
};

fn._setMapZoom = function(zoom) {
  this.zoomChangedInJavascript = true;
  this.locationsMap.setZoom(zoom);
};

fn._fetchFromMap = function() {
  const latLng = this.locationsMap.getCenter();

  let params = {};
  params[this.paramsKey] = {
    coordinates: {
      latitude: latLng.lat(),
      longitude: latLng.lng()
    },
    zoom: this.locationsMap.getZoom()
  };

  $.ajax({
    type: 'GET',
    url: this.$form.attr('action'),
    data: params,
    success: _.bind(function(result) {
      this._placeOverlays(result);
    }, this)
  });
};

function initialize(form, listContainer, paramsKey, selectCallback) {
  window.GMaps = GMaps;
  const instance = new MapsCommon(form, listContainer, paramsKey, selectCallback)
  instance._init()
  return instance
}

function createMap() {
  return fn._createMap
}

export default { initialize, createMap }
